import { CreationContactFormValues } from '../types/contactModels'
import { Client } from '../../../types/localStorageModels'
import axios from 'axios'

export const createProspect = (userData: CreationContactFormValues): Promise<Client> => axios.post('/api/sitel/contact/createProspect', userData)
	.then((response) => response.data)